import { Component, Input, OnInit } from '@angular/core';
import { Post, UserGroup } from "../../../app/app.interfaces";
import { App } from "ionic-angular";
import { UserGroupService } from "../../../services/user-group.service";
import { ObjectifyPipe } from "../../../pipes/objectify";

@Component({
  selector: 'user-group-tag-list',
  templateUrl: 'user-group-tag-list.html'
})

export class UserGroupTagList implements OnInit {

  // @Input() userGroups: UserGroup[];
  @Input() userGroupsIRIs: string[];
  @Input() showAll: boolean = true;
  @Input() showFullNames: boolean = false;
  
  userGroups: UserGroup[];
  userGroupToShow: UserGroup;
  
  constructor(public userGroupService: UserGroupService){}


  ngOnInit(): void {
    
    const objectifyPipe = new ObjectifyPipe(this.userGroupService);      

    this.userGroupService.afterInit().then(()=> {
      
      objectifyPipe.transform(this.userGroupsIRIs).then((userGroups: UserGroup[])=>{
        
        if(! this.showAll){
          if (this.userGroupService.activeUserGroup) {
            this.userGroupToShow = this.userGroupService.activeUserGroup;
          }
          else {
            this.userGroupToShow = userGroups[0];
          }
        }        
        this.userGroups = userGroups;
        
      });

    });    
    
  }
  
  
  
  
}  
    


// WEBPACK FOOTER //
// ./src/partials/user-group/user-group-tag-list/user-group-tag-list.ts